( () => {
    const activateSlide = ( slides, captions, nextIndex, currentIndexRef ) => {
        const currentIndex = currentIndexRef.value;

        if ( slides[ currentIndex ] ) {
            slides[ currentIndex ].classList.remove( 'is-active' );
        }

        if ( captions[ currentIndex ] ) {
            captions[ currentIndex ].classList.remove( 'is-active' );
        }

        if ( slides[ nextIndex ] ) {
            slides[ nextIndex ].classList.add( 'is-active' );
        }

        if ( captions[ nextIndex ] ) {
            captions[ nextIndex ].classList.add( 'is-active' );
        }

        currentIndexRef.value = nextIndex;
    };

    const initCarousel = ( block ) => {
        const slides = Array.from( block.querySelectorAll( '.gb-carousel__slide' ) );
        const captions = Array.from( block.querySelectorAll( '.gb-carousel__caption' ) );

        if ( ! slides.length ) {
            return;
        }

        const currentIndexRef = { value: 0 };

        activateSlide( slides, captions, 0, currentIndexRef );

        if (
            slides.length < 2 ||
            window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches
        ) {
            return;
        }

        const interval = Number( block.dataset.interval ) || 5000;

        window.setInterval( () => {
            const nextIndex = ( currentIndexRef.value + 1 ) % slides.length;

            activateSlide( slides, captions, nextIndex, currentIndexRef );
        }, interval );
    };

    const init = () => {
        document
            .querySelectorAll( '.wp-block-gb-carousel' )
            .forEach( ( block ) => initCarousel( block ) );
    };

    if ( document.readyState === 'loading' ) {
        document.addEventListener( 'DOMContentLoaded', init );
    } else {
        init();
    }
} )();
